/* ===== MedBound — sistema recensioni nativo (nostro, niente app a pagamento) =====
   Replica fedele del widget Junip (grafica: stelle #FDB600, summary panel,
   barre distribuzione, ordina/filtra, card con verificato + voto utile, "carica altre").
   Funziona come un'app: legge il JSON delle recensioni approvate, ordina/filtra/pagina,
   e ha un form "Scrivi una recensione" con moderazione (su Shopify -> metaobject pending).
   Stile MedBound. Nessun logo di terze parti. */
(function () {
  var RED = "#D53A2F", GOLD = "#FDB600";
  var mount = document.getElementById("mb-reviews");
  if (!mount) return;
  var SRC = mount.getAttribute("data-src") || "assets/recensioni-bundle.json";
  var PRODUCT = mount.getAttribute("data-product") || "bundle";
  var PER_PAGE = 8;
  // base path degli asset, derivato dall'URL del JSON (per le immagini delle recensioni)
  var ASSET_BASE = SRC.replace(/[^/]*\.json[^/]*$/, "");
  function imgUrl(name) { return /^(https?:)?\/\//.test(name) ? name : ASSET_BASE + name; }

  // path esatto della stella Junip (viewBox 0 0 16 16)
  var STAR = "m3.2 16.0001081c-.1687782 0-.33328968-.0531313-.47-.1521081-.24051968-.174488-.36451194-.4679107-.322-.762l.743-5.203-2.917-2.917c-.21191095-.21196521-.28756133-.52460199-.196-.81.09130759-.2851682.3345701-.49522345.63-.544l4.398-.734 2.218-4.435c.13744692-.27145241.41573373-.4426761.72-.443.3045618.00166772.58175678.1761261.715.45l2.123 4.362 4.498.801c.2933158.05211246.5333796.26289081.623.547.0898959.28455453.0135125.59548872-.198.806l-2.917 2.917.744 5.203c.042199.2957461-.0839008.5903645-.327.764-.2421349.1739598-.5609835.1986349-.827.064l-4.382-2.22-4.502 2.223c-.10996656.0547452-.23116004.0831081-.354.0831081z";

  function starSvg(color, size) {
    return '<svg viewBox="0 0 16 16" width="' + size + '" height="' + size + '" style="display:block" aria-hidden="true"><path d="' + STAR + '" fill="' + color + '"/></svg>';
  }
  // riga di 5 stelle con riempimento parziale (overlay clippato) per medie tipo 4,9
  function starsRow(value, size) {
    var pct = Math.max(0, Math.min(100, (value / 5) * 100));
    var base = "", fill = "";
    for (var i = 0; i < 5; i++) {
      base += '<span class="mb-rv-st">' + starSvg("#e4e4e7", size) + "</span>";
      fill += '<span class="mb-rv-st">' + starSvg(GOLD, size) + "</span>";
    }
    return '<span class="mb-rv-stars" role="img" aria-label="' + value.toFixed(1) + ' su 5">' +
      '<span class="mb-rv-stars-base">' + base + "</span>" +
      '<span class="mb-rv-stars-fill" style="width:' + pct + '%">' + fill + "</span>" +
      "</span>";
  }
  function esc(t) { return (t || "").replace(/[<>&"]/g, function (c) { return { "<": "&lt;", ">": "&gt;", "&": "&amp;", '"': "&quot;" }[c]; }); }
  var MESI = ["Jan.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sept.", "Okt.", "Nov.", "Dez."];
  function fmtDate(iso) {
    if (!iso) return "";
    var p = iso.split("-"); if (p.length < 3) return iso;
    return parseInt(p[2], 10) + ". " + MESI[parseInt(p[1], 10) - 1] + " " + p[0];
  }
  function initials(name) {
    var parts = (name || "?").trim().split(/\s+/);
    var s = parts[0][0] || "?";
    if (parts[1]) s += parts[1][0];
    return s.toUpperCase();
  }
  var AVCOL = ["#D53A2F", "#2f6fd5", "#1f8a4c", "#9b5de5", "#e07a1f", "#0d9488", "#c2185b", "#5b6470"];
  function avatarColor(name) {
    var h = 0; for (var i = 0; i < (name || "").length; i++) h = (h * 31 + name.charCodeAt(i)) | 0;
    return AVCOL[Math.abs(h) % AVCOL.length];
  }

  var css = '<style>' +
    '#mb-reviews{font-family:var(--font-body-family,Montserrat,sans-serif);color:#1d1d1f;max-width:1100px;margin:0 auto;padding:10px 0 30px}' +
    '#mb-reviews *{box-sizing:border-box}' +
    '.mb-rv-stars{position:relative;display:inline-flex;vertical-align:middle;line-height:0}' +
    '.mb-rv-stars-base,.mb-rv-stars-fill{display:inline-flex;gap:1px}' +
    '.mb-rv-stars-fill{position:absolute;top:0;left:0;overflow:hidden;white-space:nowrap}' +
    '.mb-rv-st{display:inline-block;padding:0 .5px}' +
    '.mb-rv-title{font-family:var(--font-body-family,Montserrat,sans-serif);font-weight:800;font-size:clamp(20px,3.2vw,26px);letter-spacing:-.015em;text-align:left;margin:0 0 22px;color:#111}' +
    // mini-sintesi sotto il titolo prodotto (stelle + conteggio, cliccabile)
    '.mb-rv-mini{display:inline-flex;align-items:center;gap:8px;cursor:pointer;text-decoration:none;line-height:1;margin:2px 0}' +
    '.mb-rv-mini .cnt{font-size:15px;color:#6b6b70;font-weight:600}' +
    '.mb-rv-mini:hover .cnt{color:#111;text-decoration:underline}' +
    // summary panel
    '.mb-rv-summary{display:grid;grid-template-columns:minmax(200px,1fr) 1.3fr auto;gap:30px;align-items:center;border:1px solid #e6e6e9;border-radius:18px;padding:26px 30px;margin-bottom:26px}' +
    '.mb-rv-score{text-align:center}' +
    '.mb-rv-score .num{font-family:var(--font-body-family,Montserrat,sans-serif);font-weight:800;font-size:64px;line-height:.9;color:#111;letter-spacing:-.03em}' +
    '.mb-rv-score .based{font-size:13px;color:#86868b;margin-top:8px}' +
    '.mb-rv-score .rec{font-size:12.5px;color:#1f8a4c;font-weight:700;margin-top:6px}' +
    '.mb-rv-bars{display:flex;flex-direction:column;gap:7px}' +
    '.mb-rv-bar{display:flex;align-items:center;gap:12px;min-height:0 !important;line-height:1;font-size:13px;color:#6b6b70;cursor:pointer;background:none;border:0;padding:6px 4px !important;border-radius:8px;font-family:inherit;width:100%;text-align:left}' +
    '.mb-rv-bar:hover{background:#f6f6f7}' +
    '.mb-rv-bar.active{background:#fdeceb}' +
    '#mb-reviews .mb-rv-bar{height:auto !important;flex:0 0 auto !important;align-self:auto !important}' +
    '.mb-rv-bar .lbl{display:block;width:14px;flex:0 0 auto;color:#3a3a3c;font-weight:700;font-size:14px;text-align:left}' +
    '.mb-rv-bar .track{flex:1;display:block;height:9px;border-radius:99px;background:#ececef;overflow:hidden}' +
    '.mb-rv-bar .fill{display:block;height:100%;background:' + RED + ';border-radius:99px}' +
    '.mb-rv-bar .cnt{width:34px;text-align:right;flex:0 0 auto;font-variant-numeric:tabular-nums}' +
    '.mb-rv-cta{display:flex;align-items:center;gap:10px}' +
    '.mb-rv-filterbtn{display:none;align-items:center;justify-content:center;gap:8px}' +
    '.mb-rv-filterbtn svg{width:16px;height:16px}' +
    '.mb-rv-div{display:none;border:0;border-top:1px solid #ededf0;margin:2px 0}' +
    '.mb-rv-fpanel{display:none;border:1px solid #e6e6e9;border-radius:14px;padding:14px 16px;margin:0 0 18px;flex-direction:column;gap:14px}' +
    '.mb-rv-fpanel.open{display:flex}' +
    '.mb-rv-fpanel .grp>span{display:block;font-size:11.5px;font-weight:800;text-transform:uppercase;letter-spacing:.08em;color:#86868b;margin-bottom:8px}' +
    '.mb-rv-fchips{display:flex;flex-wrap:wrap;gap:7px}' +
    '.mb-rv-fchip{border:1.5px solid #e0e0e4;background:#fff;border-radius:99px;padding:7px 13px;font:inherit;font-size:13px;font-weight:700;color:#46464b;cursor:pointer;display:inline-flex;align-items:center;gap:4px}' +
    '.mb-rv-fchip.active{border-color:#111;background:#111;color:#fff}' +
    '.mb-rv-btn{background:' + RED + ';color:#fff;border:0;font-weight:800;font-size:14px;padding:14px 24px;border-radius:99px;cursor:pointer;font-family:inherit;white-space:nowrap;transition:background .15s}' +
    '.mb-rv-btn:hover{background:#b73225}' +
    '.mb-rv-btn.ghost{background:#fff;color:#111;border:1.5px solid #d6d6da}' +
    '.mb-rv-btn.ghost:hover{background:#111;color:#fff;border-color:#111}' +
    // toolbar
    '.mb-rv-toolbar{display:flex;align-items:center;justify-content:space-between;gap:14px;flex-wrap:wrap;margin-bottom:16px}' +
    '.mb-rv-shown{font-size:13.5px;color:#86868b}' +
    '.mb-rv-shown b{color:#1d1d1f}' +
    '.mb-rv-filterchip{display:none;align-items:center;gap:6px;font-size:12.5px;background:#fdeceb;color:' + RED + ';border:0;border-radius:99px;padding:5px 12px;cursor:pointer;font-family:inherit;font-weight:700;margin-left:8px}' +
    '.mb-rv-filterchip.on{display:inline-flex}' +
    '.mb-rv-sortwrap{display:flex;align-items:center;gap:8px}' +
    '.mb-rv-sortwrap label{font-size:13px;color:#86868b}' +
    '.mb-rv-sort{font-family:inherit;font-size:13.5px;font-weight:600;color:#1d1d1f;border:1.5px solid #e0e0e4;background:#fff;border-radius:10px;padding:9px 12px;cursor:pointer}' +
    // list (single column, Junip-like)
    '.mb-rv-list{display:flex;flex-direction:column}' +
    '.mb-rv-card{display:grid;grid-template-columns:48px 1fr;gap:16px;padding:24px 2px;border-top:1px solid #ededf0}' +
    '.mb-rv-av{width:48px;height:48px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:#f3e8ee;color:#a98ea0;flex:0 0 48px}' +
    '.mb-rv-av svg{width:30px;height:30px}' +
    '.mb-rv-main .row1{display:flex;align-items:center;gap:8px;flex-wrap:wrap}' +
    '.mb-rv-main .who{font-weight:700;font-size:15.5px;color:#111}' +
    '.mb-rv-main .ver{display:inline-flex;align-items:center;gap:5px;font-size:12.5px;color:#3a3a3c;font-weight:600}' +
    '.mb-rv-main .ver svg{width:15px;height:15px}' +
    '.mb-rv-main .row2{display:flex;align-items:center;justify-content:space-between;gap:10px;margin:8px 0 2px}' +
    '.mb-rv-main .date{font-size:12.5px;color:#a1a1a6}' +
    '.mb-rv-main .rttl{font-weight:800;font-size:15px;color:#111;margin:6px 0 5px}' +
    '.mb-rv-main .rbody{font-size:14px;line-height:1.6;color:#46464b}' +
    '.mb-rv-main .rec{display:inline-flex;align-items:center;gap:5px;font-size:12.5px;color:#1f8a4c;font-weight:600;margin-top:11px}' +
    '.mb-rv-main .rec svg{width:14px;height:14px}' +
    '.mb-rv-help{display:flex;align-items:center;gap:12px;margin-top:13px;font-size:12.5px;color:#86868b}' +
    '.mb-rv-help button{display:inline-flex;align-items:center;gap:5px;border:1.5px solid #e2e2e6;background:#fff;border-radius:99px;padding:5px 12px;font-family:inherit;font-size:12.5px;color:#46464b;cursor:pointer}' +
    '.mb-rv-help button:hover{border-color:#111;color:#111}' +
    '.mb-rv-help button.voted{border-color:' + RED + ';color:' + RED + '}' +
    // load more
    '.mb-rv-more{display:flex;justify-content:center;margin-top:26px}' +
    // form
    '.mb-rv-ok{display:none;background:#eafaf0;border:1px solid #bfe3cb;color:#1f6b3a;border-radius:12px;padding:15px 18px;font-size:14px;margin-bottom:18px}' +
    '.mb-rv-form{border:1px solid #e6e6e9;border-radius:16px;padding:26px;margin-bottom:26px;display:none;background:#fafafa}' +
    '.mb-rv-form.open{display:block}' +
    '.mb-rv-form h3{font-family:var(--font-heading-family,"Passion One",sans-serif);font-weight:400;font-size:30px;margin:0 0 4px;color:#111}' +
    '.mb-rv-form p.sub{font-size:13px;color:#86868b;margin:0 0 16px}' +
    '.mb-rv-form label{display:block;font-size:13px;font-weight:700;color:#3a3a3c;margin:14px 0 6px}' +
    '.mb-rv-form input,.mb-rv-form textarea{width:100%;border:1.5px solid #dcdce0;border-radius:11px;padding:12px 14px;font:inherit;font-size:14px;outline:none;background:#fff}' +
    '.mb-rv-form input:focus,.mb-rv-form textarea:focus{border-color:#111}' +
    '.mb-rv-pick{display:inline-flex;gap:3px;cursor:pointer}' +
    '.mb-rv-pick .mb-rv-st{cursor:pointer}' +
    '.mb-rv-note{font-size:12px;color:#9a9aa0;margin-top:14px}' +
    '.mb-rv-grid2{display:grid;grid-template-columns:1fr 1fr;gap:14px}' +
    '@media(max-width:720px){' +
      '.mb-rv-title{font-size:23px;margin:0 0 14px}' +
      '.mb-rv-summary{grid-template-columns:auto 1fr;gap:4px 18px;border:0;padding:0;align-items:start;text-align:left;margin-bottom:18px}' +
      '.mb-rv-score{text-align:left}.mb-rv-score .num{font-size:50px}.mb-rv-score .based{margin-top:4px}' +
      '.mb-rv-cta{grid-column:1/-1;flex-direction:column;align-items:stretch;margin-top:10px}' +
      '.mb-rv-btn{width:100%;text-align:center}' +
      '.mb-rv-filterbtn{display:inline-flex}' +
      '.mb-rv-div{display:block}' +
      '.mb-rv-toolbar .mb-rv-sortwrap{display:none}' +
      '.mb-rv-grid2{grid-template-columns:1fr}' +
    '}' +
    // ---- foto clienti: striscia + lightbox ----
    '.mb-rv-photos{margin:2px 0 24px}' +
    '.mb-rv-photos h3{font-weight:800;font-size:15px;color:#111;margin:0 0 12px}' +
    '.mb-rv-photos .strip{display:flex;gap:10px;overflow-x:auto;padding-bottom:4px;-webkit-overflow-scrolling:touch}' +
    '.mb-rv-photos .strip::-webkit-scrollbar{height:0}' +
    '.mb-rv-photo{flex:0 0 auto;width:94px;height:94px;border-radius:14px;overflow:hidden;cursor:pointer;border:0;padding:0;background:#f3f3f5}' +
    '.mb-rv-photo img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .25s}' +
    '.mb-rv-photo:hover img{transform:scale(1.06)}' +
    '.mb-rv-cardimg{margin:10px 0 2px}' +
    '.mb-rv-cardimg button{width:74px;height:74px;border-radius:10px;overflow:hidden;border:0;padding:0;cursor:pointer;background:#f3f3f5}' +
    '.mb-rv-cardimg img{width:100%;height:100%;object-fit:cover;display:block}' +
    '.mb-rv-lb{position:fixed;inset:0;z-index:2147483600;display:none;align-items:center;justify-content:center;background:rgba(13,20,33,.72);padding:20px}' +
    '.mb-rv-lb.open{display:flex}' +
    '.mb-rv-lb__card{background:#fff;border-radius:20px;overflow:hidden;max-width:920px;width:100%;max-height:90vh;display:grid;grid-template-columns:1fr 1fr;box-shadow:0 30px 80px rgba(0,0,0,.4);position:relative}' +
    '.mb-rv-lb__img{background:#0d1421;display:flex;align-items:center;justify-content:center;min-height:0}' +
    '.mb-rv-lb__img img{width:100%;height:100%;max-height:90vh;object-fit:contain;display:block}' +
    '.mb-rv-lb__txt{padding:34px 32px 30px;overflow-y:auto}' +
    '.mb-rv-lb__txt .row2{display:flex;align-items:center;justify-content:space-between;gap:10px;margin:12px 0 0}' +
    '.mb-rv-lb__txt .who{font-weight:700;font-size:16px;color:#111}' +
    '.mb-rv-lb__txt .date{font-size:13px;color:#a1a1a6}' +
    '.mb-rv-lb__txt .ver{display:inline-flex;align-items:center;gap:5px;font-size:12.5px;color:#3a3a3c;font-weight:600;margin:8px 0 0}' +
    '.mb-rv-lb__txt .ver svg{width:15px;height:15px}' +
    '.mb-rv-lb__txt .rttl{font-weight:800;font-size:17px;color:#111;margin:16px 0 8px}' +
    '.mb-rv-lb__txt .rbody{font-size:15px;line-height:1.65;color:#46464b}' +
    '.mb-rv-lb__txt .lbrec{display:inline-flex;align-items:center;gap:5px;font-size:12.5px;color:#1f8a4c;font-weight:600;margin-top:14px}' +
    '.mb-rv-lb__txt .lbrec svg{width:14px;height:14px}' +
    '.mb-rv-lb__close{position:absolute;top:12px;right:12px;z-index:3;width:38px !important;height:38px !important;min-width:0 !important;max-width:38px !important;flex:0 0 auto;aspect-ratio:1;border-radius:50% !important;border:0;padding:0 !important;background:rgba(255,255,255,.92);color:#111;font-size:22px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 10px rgba(0,0,0,.2)}' +
    '.mb-rv-lb__nav{position:absolute;top:50%;transform:translateY(-50%);z-index:3;width:42px !important;height:42px !important;min-width:0 !important;max-width:42px !important;flex:0 0 auto;aspect-ratio:1;border-radius:50% !important;border:0;padding:0 !important;background:rgba(255,255,255,.92);color:#111;font-size:24px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 10px rgba(0,0,0,.2)}' +
    '.mb-rv-lb__nav.prev{left:12px}.mb-rv-lb__nav.next{right:12px}' +
    '@media(max-width:720px){.mb-rv-lb__card{grid-template-columns:1fr;max-height:92vh;overflow-y:auto}.mb-rv-lb__img img{max-height:46vh}.mb-rv-lb__txt{padding:20px}.mb-rv-photo{width:80px;height:80px}.mb-rv-lb__nav{top:23vh}}' +
    '</style>';

  var CHECK = '<svg viewBox="0 0 16 16" fill="none"><path d="M13.5 4.5 6.5 11.5 3 8" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var THUMB = '<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M7 11v9H4a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h3Zm0 0 4.5-7.5a2 2 0 0 1 3.7 1.3L14 9h4.6a2 2 0 0 1 2 2.5l-1.6 7A2 2 0 0 1 17 20H7" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>';
  var PERSON = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4.4 3.6-7 8-7s8 2.6 8 7z"/></svg>';
  var SEAL = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10" fill="' + RED + '"/><path d="M8 12.3l2.6 2.6 5-5.4" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var DATA = null, state = { sort: "recent", filter: 0, page: 1 };
  var voted = {};
  try { voted = JSON.parse(localStorage.getItem("mb_rv_voted_" + PRODUCT) || "{}"); } catch (e) { }

  function workingSet() {
    var arr = DATA.reviews.slice();
    if (state.filter) arr = arr.filter(function (r) { return r.rating === state.filter; });
    arr.sort(function (a, b) {
      if (state.sort === "recent") return (b.date || "").localeCompare(a.date || "");
      if (state.sort === "helpful") return (b.helpful || 0) - (a.helpful || 0);
      if (state.sort === "high") return b.rating - a.rating || (b.date || "").localeCompare(a.date || "");
      if (state.sort === "low") return a.rating - b.rating || (b.date || "").localeCompare(a.date || "");
      return 0;
    });
    return arr;
  }

  function reviewCard(r, idx) {
    var col = avatarColor(r.name);
    var v = voted[idx];
    return '<div class="mb-rv-card">' +
      '<div class="mb-rv-av">' + PERSON + '</div>' +
      '<div class="mb-rv-main">' +
      '<div class="row1"><span class="who">' + esc(r.name) + '</span>' +
      (r.verified ? '<span class="ver">' + SEAL + ' Verifizierter Käufer</span>' : '') + '</div>' +
      '<div class="row2">' + starsRow(r.rating, 15) + '<span class="date">' + fmtDate(r.date) + '</span></div>' +
      '<div class="rttl">' + esc(r.title) + '</div>' +
      '<div class="rbody">' + esc(r.body) + '</div>' +
      (r.image ? '<div class="mb-rv-cardimg"><button type="button" data-lb="' + idx + '" aria-label="Kundenfoto ansehen"><img loading="lazy" src="' + imgUrl(r.thumb || r.image) + '" alt="Kundenfoto"></button></div>' : '') +
      (r.recommend ? '<div class="rec">' + CHECK + ' Empfiehlt dieses Produkt</div>' : '') +
      '<div class="mb-rv-help">War das hilfreich für dich?' +
      '<button data-vote="' + idx + '" class="' + (v ? 'voted' : '') + '">' + THUMB + ' <span>Ja</span> <b>' + ((r.helpful || 0) + (v ? 1 : 0)) + '</b></button>' +
      '</div></div></div>';
  }

  function renderList() {
    var arr = workingSet();
    var shown = Math.min(state.page * PER_PAGE, arr.length);
    var cards = "";
    for (var i = 0; i < shown; i++) cards += reviewCard(arr[i], DATA.reviews.indexOf(arr[i]));
    document.getElementById("mb-rv-list").innerHTML = cards || '<p style="padding:30px;text-align:center;color:#9a9aa0">Keine Bewertungen mit diesem Filter.</p>';
    document.getElementById("mb-rv-shown").innerHTML = 'Angezeigt <b>' + shown + '</b> von <b>' + arr.length + '</b> Bewertungen';
    var more = document.getElementById("mb-rv-more");
    more.innerHTML = shown < arr.length ? '<button class="mb-rv-btn ghost" id="mb-rv-loadmore">Weitere Bewertungen laden</button>' : '';
    if (shown < arr.length) document.getElementById("mb-rv-loadmore").onclick = function () { state.page++; renderList(); };
    // bind votes
    document.querySelectorAll("#mb-rv-list [data-vote]").forEach(function (btn) {
      btn.onclick = function () {
        var k = btn.getAttribute("data-vote");
        if (voted[k]) { delete voted[k]; } else { voted[k] = 1; }
        localStorage.setItem("mb_rv_voted_" + PRODUCT, JSON.stringify(voted));
        renderList();
      };
    });
    // chip state
    var chip = document.getElementById("mb-rv-chip");
    if (state.filter) { chip.classList.add("on"); chip.querySelector("span").textContent = state.filter + " Sterne"; }
    else chip.classList.remove("on");
    document.querySelectorAll(".mb-rv-bar").forEach(function (b) {
      b.classList.toggle("active", +b.getAttribute("data-star") === state.filter);
    });
    document.querySelectorAll(".mb-rv-fchip").forEach(function (c) {
      c.classList.toggle("active", +c.getAttribute("data-fstar") === state.filter);
    });
  }

  fetch(SRC).then(function (r) { return r.json(); }).then(function (data) {
    DATA = data;
    var s = data.summary, dist = s.distribution || {}, total = s.count || data.reviews.length;
    var bars = [5, 4, 3, 2, 1].map(function (k) {
      var val = dist[k] || dist[String(k)] || 0, pct = total ? Math.round(val / total * 100) : 0;
      return '<button class="mb-rv-bar" data-star="' + k + '" title="' + val + ' Bewertungen">' +
        '<span class="lbl">' + k + '</span>' +
        '<span class="track"><span class="fill" style="width:' + pct + '%"></span></span>' +
        '</button>';
    }).join("");

    mount.innerHTML = css +
      '<h2 class="mb-rv-title">Kundenbewertungen</h2>' +
      '<div class="mb-rv-summary">' +
      '<div class="mb-rv-score"><div class="num">' + s.average.toFixed(2).replace(".", ",") + '</div>' +
      starsRow(s.average, 20) +
      '<div class="based">Basierend auf ' + total + ' Bewertungen</div>' +
      (s.recommend != null ? '<div class="rec">' + s.recommend + '% empfehlen es</div>' : '') + '</div>' +
      '<div class="mb-rv-bars">' + bars + '</div>' +
      '<div class="mb-rv-cta"><button class="mb-rv-btn" id="mb-rv-toggle">Schreib eine Bewertung</button>' +
      '<hr class="mb-rv-div">' +
      '<button class="mb-rv-btn ghost mb-rv-filterbtn" id="mb-rv-filterbtn"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 5h18l-7 8v6l-4 2v-8z"/></svg> Filtern</button></div>' +
      '</div>' +

      '<div class="mb-rv-fpanel" id="mb-rv-fpanel">' +
      '<div class="grp"><span>Nach Sternen filtern</span><div class="mb-rv-fchips">' +
      '<button class="mb-rv-fchip" data-fstar="0">Alle</button>' +
      [5, 4, 3, 2, 1].map(function (k) { return '<button class="mb-rv-fchip" data-fstar="' + k + '">' + k + ' ' + starSvg(GOLD, 12) + '</button>'; }).join("") +
      '</div></div>' +
      '<div class="grp"><span>Sortieren nach</span>' +
      '<select class="mb-rv-sort" id="mb-rv-sort2" style="width:100%">' +
      '<option value="recent">Neueste zuerst</option>' +
      '<option value="helpful">Hilfreichste</option>' +
      '<option value="high">Höchste Bewertung</option>' +
      '<option value="low">Niedrigste Bewertung</option></select></div>' +
      '</div>' +

      '<div class="mb-rv-ok" id="mb-rv-ok">Danke! Deine Bewertung wurde abgeschickt und wartet <b>auf Freigabe</b>. Sie wird nach der Prüfung durch unser Team veröffentlicht.</div>' +

      '<form class="mb-rv-form" id="mb-rv-form">' +
      '<h3>Schreib eine Bewertung</h3><p class="sub">Teil deine Erfahrung mit diesem Produkt.</p>' +
      '<label>Deine Bewertung</label>' +
      '<div class="mb-rv-pick" id="mb-rv-pick" data-val="0">' +
      [1, 2, 3, 4, 5].map(function (i) { return '<span class="mb-rv-st" data-i="' + i + '">' + starSvg("#e4e4e7", 30) + '</span>'; }).join("") + '</div>' +
      '<div class="mb-rv-grid2"><div><label>Name</label><input id="mb-rv-name" maxlength="40" placeholder="z. B. Lena M." required></div>' +
      '<div><label>E-Mail (wird nicht veröffentlicht)</label><input id="mb-rv-email" type="email" maxlength="80" placeholder="du@beispiel.de" required></div></div>' +
      '<label>Titel</label><input id="mb-rv-rtitle" maxlength="70" placeholder="Fass es in wenigen Worten zusammen" required>' +
      '<label>Deine Bewertung</label><textarea id="mb-rv-body" rows="4" maxlength="700" placeholder="Was hat dir gefallen? Hat es dir beim Lernen geholfen?" required></textarea>' +
      '<div style="margin-top:18px"><button type="submit" class="mb-rv-btn">Bewertung absenden</button></div>' +
      '<div class="mb-rv-note">Bewertungen werden vor der Veröffentlichung geprüft. Wir veröffentlichen nur Bewertungen von echten Käufern.</div>' +
      '</form>' +

      '<div class="mb-rv-toolbar">' +
      '<div class="mb-rv-shown" id="mb-rv-shown"></div>' +
      '<button class="mb-rv-filterchip" id="mb-rv-chip">Filter: <span></span> ✕</button>' +
      '<div class="mb-rv-sortwrap"><label for="mb-rv-sort">Sortieren nach</label>' +
      '<select class="mb-rv-sort" id="mb-rv-sort">' +
      '<option value="recent">Neueste zuerst</option>' +
      '<option value="helpful">Hilfreichste</option>' +
      '<option value="high">Höchste Bewertung</option>' +
      '<option value="low">Niedrigste Bewertung</option></select></div>' +
      '</div>' +
      '<div class="mb-rv-list" id="mb-rv-list"></div>' +
      '<div class="mb-rv-more" id="mb-rv-more"></div>';

    renderList();

    // ---- Foto dei clienti: striscia (stile Amazon) + lightbox al click ----
    (function () {
      var photos = [];
      DATA.reviews.forEach(function (r, i) { if (r.image) photos.push({ r: r, idx: i }); });
      if (!photos.length) return;
      var stripHtml = '<div class="mb-rv-photos"><h3>Fotos von Kund:innen</h3><div class="strip">' +
        photos.map(function (o) {
          return '<button type="button" class="mb-rv-photo" data-lb="' + o.idx + '" aria-label="Kundenfoto ansehen">' +
            '<img loading="lazy" src="' + imgUrl(o.r.thumb || o.r.image) + '" alt="Kundenfoto"></button>';
        }).join("") + '</div></div>';
      var sumEl = mount.querySelector(".mb-rv-summary");
      if (sumEl) sumEl.insertAdjacentHTML("afterend", stripHtml);

      var lb = document.createElement("div");
      lb.className = "mb-rv-lb"; lb.id = "mb-rv-lb";
      lb.innerHTML = '<div class="mb-rv-lb__card">' +
        '<button type="button" class="mb-rv-lb__close" aria-label="Schließen">&times;</button>' +
        '<button type="button" class="mb-rv-lb__nav prev" aria-label="Zurück">&#8249;</button>' +
        '<button type="button" class="mb-rv-lb__nav next" aria-label="Weiter">&#8250;</button>' +
        '<div class="mb-rv-lb__img"><img alt="Kundenfoto"></div>' +
        '<div class="mb-rv-lb__txt"></div></div>';
      document.body.appendChild(lb);

      var cur = 0;
      function showLb() {
        var r = photos[cur].r;
        lb.querySelector(".mb-rv-lb__img img").src = imgUrl(r.image);
        lb.querySelector(".mb-rv-lb__txt").innerHTML =
          starsRow(r.rating, 16) +
          '<div class="row2"><span class="who">' + esc(r.name) + '</span><span class="date">' + fmtDate(r.date) + '</span></div>' +
          (r.verified ? '<div class="ver">' + SEAL + ' Verifizierter Käufer</div>' : '') +
          '<div class="rttl">' + esc(r.title) + '</div>' +
          '<div class="rbody">' + esc(r.body) + '</div>' +
          (r.recommend ? '<div class="lbrec">' + CHECK + ' Empfiehlt dieses Produkt</div>' : '');
        var disp = photos.length > 1 ? "flex" : "none";
        lb.querySelectorAll(".mb-rv-lb__nav").forEach(function (n) { n.style.display = disp; });
      }
      function openLb(idx) {
        var pos = 0; for (var i = 0; i < photos.length; i++) { if (photos[i].idx === idx) { pos = i; break; } }
        cur = pos; showLb(); lb.classList.add("open"); document.body.style.overflow = "hidden";
      }
      function closeLb() { lb.classList.remove("open"); document.body.style.overflow = ""; }
      lb.querySelector(".mb-rv-lb__close").onclick = closeLb;
      lb.querySelector(".prev").onclick = function () { cur = (cur - 1 + photos.length) % photos.length; showLb(); };
      lb.querySelector(".next").onclick = function () { cur = (cur + 1) % photos.length; showLb(); };
      lb.addEventListener("click", function (e) { if (e.target === lb) closeLb(); });
      document.addEventListener("keydown", function (e) {
        if (!lb.classList.contains("open")) return;
        if (e.key === "Escape") closeLb();
        else if (e.key === "ArrowLeft") lb.querySelector(".prev").click();
        else if (e.key === "ArrowRight") lb.querySelector(".next").click();
      });
      // delega: striscia + miniature nelle card (sopravvive ai re-render della lista)
      mount.addEventListener("click", function (e) {
        var t = e.target.closest ? e.target.closest("[data-lb]") : null;
        if (t) { e.preventDefault(); openLb(+t.getAttribute("data-lb")); }
      });
    })();

    // mini-sintesi sotto il titolo prodotto + scroll alle recensioni
    function scrollToReviews(e) {
      if (e) e.preventDefault();
      var tgt = document.getElementById("mb-reviews-section") || mount;
      var start = window.pageYOffset;
      var end = tgt.getBoundingClientRect().top + start - 80;
      var dur = 520, t0 = null, done = false;
      function step(ts) {
        if (done) return;
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var ease = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        window.scrollTo(0, start + (end - start) * ease);
        if (p < 1) requestAnimationFrame(step); else done = true;
      }
      requestAnimationFrame(step);
      // fallback: se l'animazione non è partita (rAF non disponibile/throttled), salta diretto
      setTimeout(function () {
        if (!done && Math.abs(window.pageYOffset - start) < 2) { window.scrollTo(0, end); done = true; }
      }, 100);
    }
    var mini = document.getElementById("mb-rv-mini");
    if (mini) {
      mini.innerHTML = starsRow(s.average, 18) + '<span class="cnt">(' + total + ')</span>';
      mini.setAttribute("title", "Lies die " + total + " Bewertungen");
      mini.addEventListener("click", scrollToReviews);
    }

    // toolbar bindings
    function setSort(v) { state.sort = v; var a = document.getElementById("mb-rv-sort"), b = document.getElementById("mb-rv-sort2"); if (a) a.value = v; if (b) b.value = v; state.page = 1; renderList(); }
    document.getElementById("mb-rv-sort").onchange = function () { setSort(this.value); };
    var sort2 = document.getElementById("mb-rv-sort2"); if (sort2) sort2.onchange = function () { setSort(this.value); };
    document.querySelectorAll(".mb-rv-bar").forEach(function (b) {
      b.onclick = function () {
        var st = +b.getAttribute("data-star");
        state.filter = (state.filter === st) ? 0 : st; state.page = 1; renderList();
      };
    });
    document.getElementById("mb-rv-chip").onclick = function () { state.filter = 0; state.page = 1; renderList(); };
    var fbtn = document.getElementById("mb-rv-filterbtn");
    if (fbtn) fbtn.onclick = function () { document.getElementById("mb-rv-fpanel").classList.toggle("open"); };
    document.querySelectorAll(".mb-rv-fchip").forEach(function (c) {
      c.onclick = function () { state.filter = +c.getAttribute("data-fstar"); state.page = 1; renderList(); };
    });

    // form bindings
    document.getElementById("mb-rv-toggle").onclick = function () {
      var f = document.getElementById("mb-rv-form"); f.classList.toggle("open");
      if (f.classList.contains("open")) f.scrollIntoView({ behavior: "smooth", block: "center" });
    };
    var pick = document.getElementById("mb-rv-pick");
    pick.querySelectorAll("span").forEach(function (sp) {
      sp.onclick = function () {
        var v = +sp.dataset.i; pick.dataset.val = v;
        pick.querySelectorAll("span").forEach(function (x) {
          x.querySelector("path").setAttribute("fill", +x.dataset.i <= v ? GOLD : "#e4e4e7");
        });
      };
    });
    document.getElementById("mb-rv-form").addEventListener("submit", function (e) {
      e.preventDefault();
      var rev = {
        rating: +pick.dataset.val || 5,
        name: document.getElementById("mb-rv-name").value,
        email: document.getElementById("mb-rv-email").value,
        title: document.getElementById("mb-rv-rtitle").value,
        body: document.getElementById("mb-rv-body").value,
        product: PRODUCT, status: "pending", submitted: new Date().toISOString().slice(0, 10)
      };
      var pend = JSON.parse(localStorage.getItem("mb_reviews_pending") || "[]");
      pend.push(rev); localStorage.setItem("mb_reviews_pending", JSON.stringify(pend));
      if(window.mbLead) window.mbLead({ notifyOnly:true, email:rev.email, sourceLabel:"Recensione "+PRODUCT, body:"Nuova recensione ("+rev.rating+"/5) — "+PRODUCT+"\nNome: "+rev.name+"\nEmail: "+rev.email+"\nTitolo: "+rev.title+"\n\n"+rev.body });
      e.target.reset(); pick.dataset.val = 0;
      pick.querySelectorAll("span path").forEach(function (p) { p.setAttribute("fill", "#e4e4e7"); });
      e.target.classList.remove("open");
      var ok = document.getElementById("mb-rv-ok"); ok.style.display = "block"; ok.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }).catch(function () {
    mount.innerHTML = "<p style='text-align:center;color:#9a9aa0;padding:40px'>Bewertungen momentan nicht verfügbar.</p>";
  });
})();
